import { render, staticRenderFns } from "./MedicalEvaluationPrint.vue?vue&type=template&id=0f5cd681&"
import script from "./MedicalEvaluationPrint.vue?vue&type=script&lang=js&"
export * from "./MedicalEvaluationPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports